<template>
  <div>
    <el-dialog
      title="预设坐标"
      :visible.sync="dialogVisible"
      :append-to-body="true"
      width="22%"
      @close="close"
    >
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item
          label="账号"
          prop="Architecture"
          :rules="{
            required: true,
            message: '请选择接警绑定单位',
            trigger: 'change'
          }"
        >
          <el-select
            v-model="form.Architecture"
            placeholder="请选择接警绑定单位"
            @change="change"
          >
            <el-option
              v-for="item in accountNumber"
              :key="item.USER_ID"
              :label="item.USER_NAME"
              :value="item.USER_ID"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="经度">
          <el-input v-model="form.lng" placeholder="请输入经度" />
        </el-form-item>
        <el-form-item label="纬度">
          <el-input v-model="form.lat" placeholder="请输入纬度" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="fnAccountNumber('form')"
        >确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { queryJccUserList, insertCalledUser } from '@/api/dataV'
export default {
  components: {},
  props: {},
  data() {
    return {
      dialogVisible: false,
      form: {
        Architecture: '',
        lng: '',
        lat: ''
      },
      accountNumber: [
        {
          USER_ID: '', // 账号ID
          USER_NAME: '' // 用户名称
        }
      ]
    }
  },
  computed: {},
  watch: {},
  created() {
    this.$EventBus.$on('yuseh', () => {
      this.dialogVisible = true
    })

    this.fnqueryJccUserList()
  },
  mounted() {},
  methods: {
    open() {
      this.dialogVisible = true
    },
    fnqueryJccUserList() {
      queryJccUserList(this.$store.getters.token).then(res => {
        if (res.code == 200) {
          // eslint-disable-line
          this.accountNumber = res.data
        }
      })
    },
    change(value) {},
    fnAccountNumber(form) {
      this.$refs[form].validate(values => {
        if (values) {
          // alert(1111)
          insertCalledUser(this.$store.getters.token, this.form).then(res => {
            if (res.code == 200) {
              // eslint-disable-line
              this.$message.success('添加成功')
              this.dialogVisible = false
            }
          })
        } else {
          // alert(22222)
        }
      })
    },
    close() {
      const data = {}
      data.Architecture = ''
      data.lng = ''
      data.lat = ''
      this.form = data
    }
  }
}
</script>

<style scoped lang="scss">
.el-input {
  width: 260px;
}
</style>
